/* esm.sh - applesauce-common@5.2.0/dist/helpers/bookmark */
export * from "/*applesauce-common@5.2.0/esnext/dist/helpers/bookmark.mjs";
